import React, { useState } from 'react';
import { InstagramIcon, LinkedinIcon, X } from 'lucide-react';
const PrivacyModal = ({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-105">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-106">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-107">
          <h2 className="text-2xl font-bold text-promred-gray" data-id="element-108">
            Política de Privacidad y Protección de Datos
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors" aria-label="Cerrar" data-id="element-109">
            <X size={24} data-id="element-110" />
          </button>
        </div>

        <div className="px-6 py-6 overflow-y-auto max-h-[calc(90vh-80px)]" data-id="element-111">
          <div className="prose prose-sm max-w-none" data-id="element-112">
            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-113">
              1. INTRODUCCIÓN
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-114">
              En PromRed valoramos y respetamos la privacidad de nuestros
              usuarios. Esta Política de Privacidad describe cómo recopilamos,
              utilizamos, almacenamos y protegemos los datos personales que
              usted nos proporciona al utilizar nuestros sitios, APPs,
              terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-115">
              2. RESPONSABLE DEL TRATAMIENTO
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-116">
              Nombre de la entidad: Promred SAS
            </p>
            <p className="text-gray-600 mb-2" data-id="element-117">
              Dirección Legal: Edificio The Point, Oficina 1803, Puerto Santa
              Ana, Guayaquil, Ecuador.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-118">
              Correo electrónico de contacto: contacto@promred.ec
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-119">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-120">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-121">
              <li data-id="element-122">Nombres y apellidos</li>
              <li data-id="element-123">Número de Cédula</li>
              <li data-id="element-124">Correo electrónico</li>
              <li data-id="element-125">Número de teléfono</li>
              <li data-id="element-126">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-127">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
            </ul>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-128">
              4. FINALIDAD DEL TRATAMIENTO
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-129">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-130">
              <li data-id="element-131">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-132">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-133">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-134">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-135">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-136">Cumplir con obligaciones legales y regulatorias</li>
            </ul>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-137">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-138">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-139">
              <li data-id="element-140">Tu consentimiento expreso</li>
              <li data-id="element-141">
                El interés legítimo de PromRed para cumplir su misión
                institucional
              </li>
              <li data-id="element-142">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-143">
              6. DESTINATARIOS DE LOS DATOS
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-144">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-145">
              <li data-id="element-146">Tengamos tu consentimiento previo</li>
              <li data-id="element-147">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-148">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios) con contratos que
                garantizan la protección de tus datos
              </li>
            </ul>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-149">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-150">Tienes derecho a:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-151">
              <li data-id="element-152">Acceder a tus datos personales</li>
              <li data-id="element-153">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-154">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-155">Oponerte al tratamiento</li>
              <li data-id="element-156">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-157">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="text-gray-600 mb-4" data-id="element-158">
              Puedes ejercer estos derechos escribiéndonos a
              protecciondatos@promred.ec
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-159">
              8. USO DE COOKIES
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-160">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-161">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-162">
              PromRed aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-163">
              10. CONSERVACIÓN DE LOS DATOS
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-164">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-165">
              11. CAMBIOS A ESTA POLÍTICA
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-166">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-167">
              12. AUTORIDAD DE CONTROL
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-168">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-169">
              13. VIGENCIA
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-170">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 21 de noviembre de 2025 y permanecerá vigente hasta
              que exista una nueva versión que la reemplace.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
const CookiesModal = ({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-171">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-172">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-173">
          <h2 className="text-2xl font-bold text-promred-gray" data-id="element-174">
            Política de Cookies de PromRed
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors" aria-label="Cerrar" data-id="element-175">
            <X size={24} data-id="element-176" />
          </button>
        </div>

        <div className="px-6 py-6 overflow-y-auto max-h-[calc(90vh-80px)]" data-id="element-177">
          <div className="prose prose-sm max-w-none" data-id="element-178">
            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-179">
              1. INTRODUCCIÓN
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-180">
              En PromRed, utilizamos cookies y tecnologías similares para
              mejorar la experiencia de navegación en nuestros sitios web,
              analizar el tráfico, personalizar el contenido y mostrar anuncios
              relevantes. A continuación, te explicamos qué son las cookies,
              cómo las usamos y cómo puedes gestionarlas.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-181">
              2. ¿QUÉ SON LAS COOKIES?
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-182">
              Las cookies son pequeños archivos de texto que un sitio web
              almacena en tu dispositivo (computadora, celular o tablet) al
              visitarlo. Estas permiten que el sitio "recuerde" tus acciones o
              preferencias (como idioma, inicio de sesión, etc.) durante un
              período de tiempo determinado.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-183">
              3. ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?
            </h3>

            <h4 className="text-lg font-semibold text-promred-gray mt-4 mb-2" data-id="element-184">
              A. Cookies necesarias (técnicas):
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-185">
              Permiten la navegación en el sitio web y el uso de sus funciones
              esenciales. Sin estas cookies, el sitio no puede funcionar
              correctamente.
            </p>

            <h4 className="text-lg font-semibold text-promred-gray mt-4 mb-2" data-id="element-186">
              B. Cookies de preferencia o personalización:
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-187">
              Almacenan información para que el usuario acceda al servicio con
              características personalizadas, como el idioma o región.
            </p>

            <h4 className="text-lg font-semibold text-promred-gray mt-4 mb-2" data-id="element-188">
              C. Cookies de análisis o rendimiento:
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-189">
              Nos permiten conocer el comportamiento de los visitantes para
              mejorar el sitio. Usamos herramientas como Google Analytics u
              otras similares.
            </p>

            <h4 className="text-lg font-semibold text-promred-gray mt-4 mb-2" data-id="element-190">
              D. Cookies de publicidad o marketing:
            </h4>
            <p className="text-gray-600 mb-4" data-id="element-191">
              Recopilan información sobre tus hábitos de navegación para
              mostrarte anuncios relevantes en nuestros sitios o en otros.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-192">
              4. ¿CUÁNTO TIEMPO PERMANECEN ACTIVAS?
            </h3>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-193">
              <li data-id="element-194">
                <strong data-id="element-195">Cookies de sesión:</strong> se eliminan al cerrar el
                navegador.
              </li>
              <li data-id="element-196">
                <strong data-id="element-197">Cookies persistentes:</strong> permanecen en tu
                dispositivo hasta que las elimines o expiren.
              </li>
            </ul>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-198">
              5. ¿CÓMO PUEDES CONTROLAR LAS COOKIES?
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-199">
              Al ingresar por primera vez a nuestro sitio, se te mostrará un
              aviso de cookies. Puedes aceptar todas, rechazarlas o
              configurarlas según tu preferencia.
            </p>
            <p className="text-gray-600 mb-2" data-id="element-200">
              Además, puedes modificar la configuración de cookies desde tu
              navegador en cualquier momento:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-201">
              <li data-id="element-202">Google Chrome: Configuración de cookies</li>
              <li data-id="element-203">Mozilla Firefox: Administrar cookies</li>
              <li data-id="element-204">Safari: Soporte de Safari</li>
              <li data-id="element-205">Microsoft Edge: Privacidad y servicios</li>
            </ul>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-206">
              6. COOKIES DE TERCEROS
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-207">
              Algunas cookies pueden ser instaladas por servicios de terceros
              utilizados en nuestro sitio (como redes sociales, plataformas de
              video, servicios de estadísticas, etc.). No tenemos control
              directo sobre ellas. Te recomendamos revisar sus respectivas
              políticas:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-208">
              <li data-id="element-209">Google: Política de privacidad</li>
              <li data-id="element-210">Meta (Facebook / Instagram): Política de cookies</li>
            </ul>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-211">
              7. CAMBIOS EN ESTA POLÍTICA
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-212">
              Podemos actualizar esta Política de Cookies en cualquier momento.
              Te notificaremos en nuestro sitio web cuando se hagan cambios
              relevantes.
            </p>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-213">
              8. CONTACTO
            </h3>
            <p className="text-gray-600 mb-2" data-id="element-214">
              Si tienes dudas sobre nuestra política de cookies, puedes
              escribirnos a:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4" data-id="element-215">
              <li data-id="element-216">contacto@promred.ec</li>
            </ul>

            <h3 className="text-xl font-bold text-promred-gray mt-6 mb-3" data-id="element-217">
              9. VIGENCIA
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-218">
              La vigencia de estas Políticas es desde el 21 de noviembre de 2025
              y permanecerá vigente hasta que exista una nueva versión que la
              reemplace.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
const Footer = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isCookiesModalOpen, setIsCookiesModalOpen] = useState(false);
  return <>
      <footer className="bg-promred-gray text-white" data-id="element-219">
        <div className="container mx-auto px-4 py-12" data-id="element-220">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-221">
            <div className="md:col-span-1" data-id="element-222">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cnc1d1uuiBabHNzspzBg67/Logo_Promred.png" alt="Promred Logo" className="h-16 mb-4 bg-white p-2 rounded" data-id="element-223" />
              <p className="text-gray-300 mb-4" data-id="element-224">
                Soluciones innovadoras de fidelización y gestión de eventos para
                potenciar tu negocio.
              </p>
              <div className="flex space-x-4" data-id="element-225">
                <a href="https://www.instagram.com/promred.ec" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" aria-label="Instagram" data-id="element-226">
                  <InstagramIcon size={20} data-id="element-227" />
                </a>
                <a href="https://www.linkedin.com/company/promredec/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-228">
                  <LinkedinIcon size={20} data-id="element-229" />
                </a>
              </div>
            </div>
            <div data-id="element-230">
              <h3 className="font-bold text-lg mb-4" data-id="element-231">Empresa</h3>
              <ul className="space-y-2" data-id="element-232">
                <li data-id="element-233">
                  <a href="/nosotros" className="text-gray-300 hover:text-white transition-colors" data-id="element-234">
                    Sobre Nosotros
                  </a>
                </li>
                <li data-id="element-235">
                  <a href="/#caracteristicas" className="text-gray-300 hover:text-white transition-colors" data-id="element-236">
                    ¿Por qué elegirnos?
                  </a>
                </li>
                <li data-id="element-237">
                  <a href="/programas-clientes" className="text-gray-300 hover:text-white transition-colors" data-id="element-238">
                    Nuestros Clientes
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-239">
              <h3 className="font-bold text-lg mb-4" data-id="element-240">Información Legal</h3>
              <ul className="space-y-2" data-id="element-241">
                <li data-id="element-242">
                  <button onClick={() => setIsPrivacyModalOpen(true)} className="text-gray-300 hover:text-white transition-colors text-left" data-id="element-243">
                    Privacidad y Protección de Datos
                  </button>
                </li>
                <li data-id="element-244">
                  <button onClick={() => setIsCookiesModalOpen(true)} className="text-gray-300 hover:text-white transition-colors text-left" data-id="element-245">
                    Uso de Cookies
                  </button>
                </li>
              </ul>
            </div>
            <div data-id="element-246">
              <h3 className="font-bold text-lg mb-4" data-id="element-247">Contacto</h3>
              <ul className="space-y-2" data-id="element-248">
                <li data-id="element-249">
                  <a href="mailto:contacto@promred.ec" className="text-gray-300 hover:text-white transition-colors" data-id="element-250">
                    <strong data-id="element-251">Email:</strong> contacto@promred.ec
                  </a>
                </li>
                <li data-id="element-252"></li>
                <li data-id="element-253"></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-300" data-id="element-254">
            <p data-id="element-255">&copy; 2026 Promred SAS. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>

      <PrivacyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} data-id="element-256" />

      <CookiesModal isOpen={isCookiesModalOpen} onClose={() => setIsCookiesModalOpen(false)} data-id="element-257" />
    </>;
};
export default Footer;